import Guarantees from './views/guarantees.c';
export default Guarantees;
